import { createFileRoute } from "@tanstack/react-router";
import { NewTestPage } from "@/routes/_main/exams/$slug/test/new";

export const Route = createFileRoute("/_main/groups/$gid/exams/$slug/test/new")({
  component: NewTestPage,
});
